module.exports = __webpack_public_path__ + "img/img-aafe6b.jpg";